import { render, staticRenderFns } from "./UpdatePermissions.vue?vue&type=template&id=385a4672"
import script from "./UpdatePermissions.vue?vue&type=script&lang=js"
export * from "./UpdatePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports